module.exports = {
      id: "recipe-share-menu-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#recipe-share-menu",
      toString: function () {
        return this.url;
      }
    }